
import countries from '~/assets/data/countries_all'
export default {
  name: 'BusinessForm',
  props: ['formId', 'ctaText', 'redirectPage'],
  data() {
    return {
      formName: `${this.formId}-form`,
      formData: {},
      isLoading: false,
      submitError: false,
      countries
    }
  },
  computed:{
    currentLocale(){
      return this.$i18n.locale
    },
    formCountries() {
      return this.countries.map(country => {
        return { value: country.code, label: country.name[this.currentLocale] }
      })
    }
  },

  methods: {
    initForm(){
      this.formData = {}
      this.$formulate.resetValidation(this.formName)
    },
    async submitForm() {
      this.isLoading = true
      this.submitError = false

      const response = await this.sendToGateway({
        ...this.formData, 
        account_type: 'Business',
        acquisition_channel: 'Website Business Form',
        formName: this.formName, 
        sendEmailTo: 'sales@vitesy.com' 
      })
      if (!response || response?.accountId?.error || response?.contactId?.error) {
        this.submitError = true
      } else {
        this.trackFormSubmission()
        if (this.redirectPage) {
          window.location.href = `${this.redirectPage}?name=${this.formData.first_name}`
        } else {
          this.$emit('submitted')
        }
        setTimeout(()=>{
          this.$formulate.reset(this.formName, {})
        }, 1000)
      }
      this.isLoading = false
    },
    async sendToGateway (data) {
      try {
        const response = await fetch(
          'https://gwapi.vitesy.com/api/crm/customer/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          }
        )
        return await response.json()
      } catch(err){
        return false
      }
    },
    trackFormSubmission(){
      const eventAttributes = {
        form_name: this.formName,
        form_category: 'Business Form',
        form_url: this.$route.fullPath,
        user_data: {
          user_email: this.formData.email,
          user_name: `${this.formData.first_name} ${this.formData.last_name}`, 
          user_company: this.formData.company,
          user_country: this.formData.country,
          user_phone: this.formData.phone,
          user_category: 'Business'
        }
      }
      this.$gtm.push({ event: 'generate_lead', ...eventAttributes })
    }
  }
}
